import { header } from "components/atoms/HeaderContainer";
import Icon from "components/atoms/Icon/Icon";
import UserController from "controllers/user";
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getBillingPortalUrl } from "store/slices/card.slice";
import { getPersonalInfo } from "store/slices/user.slice";
import Button from "../../atoms/Button/Button";
import Profile from "../Profile/Profile";
import { EUserRoles } from "types/user/user.type";

const Header: React.FC<{
  token?: string;
  isLoading?: boolean;
  loggedIn?: boolean;
}> = ({ token, isLoading = true }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isSuccess: AuthLogoutIsSuccess } = useAppSelector(
    (state) => state.auth.logout
  );
  const { billingPortalIsLoading } = useAppSelector((state) => state.cards);
  const { currentPage } = useAppSelector((state) => state.ui);
  const { base, nav } = header();
  const { data: user } = useAppSelector((state) => state.user);
  const isAdmin = useMemo(() => {
    return user?.userRole === EUserRoles.ADMIN;
  }, [user?.userRole]);
  const handleLogout = async () => {
    await UserController.Auth.logout({ user, dispatch });
    navigate("/signin");
  };

  useEffect(() => {
    if (token && !AuthLogoutIsSuccess) dispatch(getPersonalInfo());
  }, []);

  return (
    <header data-testid="header" className={base()}>
      {currentPage === "back" && (
        <div
          className="flex flex-1 items-center text-white-500 gap-2 border-r border-gray-700 px-6 hover:bg-gray-700 cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow-left" size={18} /> Back{" "}
        </div>
      )}
      {currentPage === null ? (
        <div></div>
      ) : (
        <div className="flex w-full gap-4 !text-white-500  items-center p-4 pl-0">
          {/* {titles?.[currentPage]?.icon && (
            <Icon name={titles?.[currentPage]?.icon || "pulse"} size={18} />
          )}
          <h1 className="text-xl text-white-500 font-bold">
            {titles?.[currentPage]?.title}
          </h1>
          <small className="text-sm capitalize hidden md:block">
            {titles?.[currentPage]?.subtitle}
          </small> */}
        </div>
      )}
      <nav className={nav()}>
        {user && (
          <>
            {!user.isInvitedUser && !isLoading && (
              <>
                {isAdmin && (
                  <Button
                    data-testid="header-credits"
                    iconName="credits"
                    onClick={async () => {
                      // if (!user.gatewayCustomerId) {
                      //   navigate("/user/billing");
                      //   setTimeout(() => {
                      //     toast.warn(
                      //       "Please add a payment method to your account before buying credits."
                      //     );
                      //   }, 900);
                      //   return;
                      // }
                      const billingData = await dispatch(getBillingPortalUrl());
                      const url = billingData.payload.data;
                      if (!url) {
                        toast.error(
                          "Something went wrong. Please try again later."
                        );
                        return;
                      }
                      window.open(url, "_blank");
                    }}
                  >
                    {billingPortalIsLoading
                      ? "Redirecting..."
                      : "Billing Portal"}
                  </Button>
                )}
              </>
            )}
            <Profile
              name={{ name: user.firstName, lastName: user.lastName }}
              credits={user.creditBalance}
              logout={handleLogout}
              dropDown
            />
          </>
        )}
      </nav>
      {/* <div className={styles.header_nav_burger}></div> */}
    </header>
  );
};
export default Header;
